module.exports = __webpack_public_path__ + "img/banner3.b343eb8e.png";